import type React from 'react';
import { colors } from '@this/shared/ui/theme/tokens/primitive-tokens/colors';
import { getCommonStyles } from './commonStyles';

// User用スタイルをcommonStylesを拡張して定義
function getStyles() {
  const commonStyles = getCommonStyles();

  return {
    // commonStylesの要素をスプレッド
    ...commonStyles,

    // heading拡張（User固有）
    heading: {
      ...commonStyles.heading,
      primary: {
        fontSize: '24px',
        fontWeight: 'bold'
      } as React.CSSProperties,
      secondary: {
        fontSize: '20px',
        fontWeight: 'bold',
        marginBottom: '16px'
      } as React.CSSProperties
    },

    // User固有のスタイルを追加・上書き
    // ボタンセクション（確認画面用）
    buttonSection: {
      base: {
        backgroundColor: colors.gray[50],
        padding: '32px',
        borderRadius: '8px',
        marginTop: '40px',
        textAlign: 'center' as const
      } as React.CSSProperties
    },

    // テキスト
    text: {
      note: {
        fontSize: '14px',
        color: colors.gray[600]
      } as React.CSSProperties
    },

    // エラーメッセージ
    errorMessage: {
      container: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '10px'
      } as React.CSSProperties,
      text: {
        color: colors.red[600],
        fontSize: '14px',
        margin: 0
      } as React.CSSProperties
    },

    // フォームエラー
    formError: {
      text: {
        color: colors.red[600],
        fontSize: '12px',
        marginTop: '4px',
        marginBottom: '0'
      } as React.CSSProperties
    }
  };
}

export const onlineApplicationStyles = getStyles();

// 個別のスタイルオブジェクトもエクスポート（互換性のため）
export const sectionStyle = onlineApplicationStyles.section.base;
export const headingStyle = onlineApplicationStyles.heading.base;
export const gridStyle = onlineApplicationStyles.grid.single;
export const fieldStyle = onlineApplicationStyles.field.base;
export const labelStyle = onlineApplicationStyles.label.base;
export const valueStyle = onlineApplicationStyles.value.base;
